import { gql } from '@apollo/client';
import { apolloClient } from 'apollo-client';

export const FETCH_COUNTIES = gql`
  query FetchCountiesInfo($id: Int!, $zipCode: String!) {
    countyData(id: $id, zipCode: $zipCode) {
      counties
      incomeLimits
    }
  }
`;

export interface FetchCountiesParams {
  id: number;
  zipCode: string;
}

export interface FetchCountiesResponse {
  counties: string[];
  incomeLimits: Record<string, string[]>;
}

export const fetchCounties = async (
  params: FetchCountiesParams
): Promise<FetchCountiesResponse> => {
  const { id, zipCode } = params;

  const { data } = await apolloClient.query({
    query: FETCH_COUNTIES,
    variables: { id, zipCode },
    fetchPolicy: 'no-cache',
  });

  const counties = data?.countyData?.counties;
  const incomeLimits = data?.countyData?.incomeLimits || {};

  return {
    counties: counties
      ? counties.flat().filter((c: string | null): c is string => !!c)
      : [],
    incomeLimits:
      typeof incomeLimits === 'object' && incomeLimits !== null
        ? incomeLimits
        : {},
  };
};
